import React, { useContext, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { connect } from "react-redux";
import useSlider from "../../hooks/useSlider";
import cn from "classnames";
import { NavContext, showedNav } from "../../context/NavState";

import { ApiData } from "../../api";
import { media, MediaLinks } from "../../utils/StrapiUtils";

const SliderRadio = ({ value = "Зеркала", defVal, setDefVal, setAnim }) => {
  const setDefaultVale = () => {
    if (defVal) setDefVal(false);
  };
  return (
    <div onClick={setAnim} className="sliderDivRadio">
      <div className="sliderDivRadioInner">
        <Field
          checked={defVal ? value === "Зеркала" : undefined}
          onChange={setDefaultVale}
          className="slideRadio"
          component={"input"}
          value={value}
          name="choice"
          id={value}
          type={"radio"}
        />
        <label className="sliderDivInputRadio" htmlFor={value}>
          {value}
        </label>
      </div>
    </div>
  );
};

let SlidersButton = ({ sliderData, setAnim }) => {
  const [defVal, setDefVal] = useState(true);
  const setAnimation = () => {
    setAnim(true);
    setTimeout(() => {
      setAnim(false);
    }, 300);
  };
  return (
    <form className="sliderButtons">
      {Object.keys(sliderData).map((key) => {
        return (
          <SliderRadio
            key={key}
            setAnim={setAnimation}
            value={key}
            defVal={defVal}
            setDefVal={setDefVal}
          />
        );
      })}
    </form>
  );
};

SlidersButton = reduxForm({
  form: "slidersButton",
})(SlidersButton);
const selector = formValueSelector("slidersButton");

const Sliders = ({ userChoice, setModalImage }) => {
  const [settings, setSettings] = useState({
    slidesToShow: 4,
    slidesToScroll: 2,
  });
  const updateWindowDimensions = () => {
    const innerWidth = window.innerWidth;
    if (innerWidth > 992) {
      setSettings({
        slidesToShow: 4,
        slidesToScroll: 2,
      });
    } else if (innerWidth > 540) {
      setSettings({
        slidesToShow: 3,
        slidesToScroll: 3,
      });
    } else {
      setSettings({
        slidesToShow: 2,
        slidesToScroll: 2,
      });
    }
  };
  useEffect(() => {
    window.addEventListener("resize", updateWindowDimensions);
    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);
  // const [showModal, setShowModal] = useState(false)
  const [selectedImage, setSelectedImage] = useState(0);
  const [sliderData, setSlidersData] = useState<MediaLinks>({});
  const { origNavigation, setNavigationContext } = useContext(NavContext);

  useEffect(() => {
    ApiData.examples().then((res) => {
      const sData: MediaLinks = {};
      if (!res.length) return;
      showedNav.add("slider");
      setNavigationContext(origNavigation.filter((el) => showedNav.has(el.to)));
      for (const ex of res) {
        sData[ex.title] = ex.media.map(media);
      }
      setSlidersData(sData);
    });
  }, []);
  const [canOpen, setCanOpen] = useState(true);
  const timer = useRef<NodeJS.Timeout>();
  const setTimer = () => {
    timer.current = setTimeout(() => {
      setCanOpen(false);
    }, 100);
  };
  const clearTimer = () => {
    clearTimeout(timer.current);
    setCanOpen(true);
  };
  const MyImg = ({
    media,
    i,
    onClick,
  }: Record<string, any> & { media: MediaLinks }) => (
    <div
      key={i}
      onMouseDown={setTimer}
      onMouseUp={clearTimer}
      onClick={onClick}
      className="divSliderImg"
    >
      <img
        key={i + "img"}
        className="imgSlick"
        src={media.src}
        alt={media.alt}
      />
    </div>
  );
  const getImages = (v) =>
    sliderData[v ?? "Зеркала"].map((el, i) => (
      <MyImg
        i={i}
        onClick={() => {
          if (canOpen) {
            setSelectedImage(i);
            setModalImage(
              <FullScreen
                closeModal={() => setModalImage(false)}
                selectedImage={selectedImage}
                images={sliderData[userChoice ?? Object.keys(sliderData)[0]]}
              />,
            );
          } else setCanOpen(true);
        }}
        key={i}
        media={el}
      />
    ));
  const [anim, setAnim] = useState(false);
  return Object.keys(sliderData).length ? (
    <div className="blockContent">
      <div id="slider" className="blockSlider">
        <div className="bl_2_head_text_box">
          <div className="titles">Примеры работ</div>
          <SlidersButton setAnim={setAnim} sliderData={sliderData} />
        </div>
        <Slider
          className={cn({ sliderAnimation: anim, sliderAnimation2: !anim })}
          {...settings}
          autoplay
          autoplaySpeed={2500}
          infinite
          speed={500}
          arrows
        >
          {getImages(userChoice)}
        </Slider>
      </div>
    </div>
  ) : (
    <></>
  );
};

const FullScreen = ({ images, selectedImage, closeModal }) => {
  const slideImage = useRef(null);
  const { goToPreviousSlide, goToNextSlide, selectSlide } = useSlider(
    slideImage,
    images,
  );
  useEffect(() => selectSlide(selectedImage), []);
  return (
    <div className="sliderFullScreen">
      <div className="slider--content">
        <button
          onClick={goToPreviousSlide}
          className="slider__btn slider__btn_left"
        >
          <i className="imageArrow leftArr"></i>
        </button>
        <img className="fullScreenImage" alt="" ref={slideImage} />
        <div
          onClick={() => {
            selectSlide(null);
            closeModal(false);
          }}
          className="divBtn--imageClose"
        >
          <a rel="noreferrer" className="button--imageClose" />
        </div>
        <button
          onClick={goToNextSlide}
          className="slider__btn slider__btn_right"
        >
          <i className="imageArrow rightArr"></i>
        </button>
      </div>
    </div>
  );
};

export default connect((state) => ({
  userChoice: selector(state, "choice"),
}))(Sliders);
